export default __webpack_public_path__ + "static/media/ic_stats_big.1fde9e52.svg";